import {
    useMemo,
} from 'react'
import {
    SkyNetDomainRoutes,
    SkyNetDomainSubRoutes,
} from 'app/shared-components/SkyNetDomain/useCreateSkyNetDomainRoutes'
import {
    useSkyNetNavigate,
} from 'app/SkyNetRoutes/index'
import {
    createRoutesConfig,
} from 'app/SkyNetRoutes/skyNetRoutes.utils'
import {
    RouteNode,
} from 'app/SkyNetRoutes/SkyNetRoutes.types'
import {
    App,
    RatesDomains,
    RateCardsTabs,
} from 'app/enums/domain.enums'
import {
    CommonRoutes,
} from 'app/enums/common.enums'

export default function useRatesRoutes(): {
    ARateCards: RouteNode,
    CRateCards: RouteNode,
    } {
    const skyNetNavigate = useSkyNetNavigate()

    return useMemo(() => {
        const config = {
            path: [App.Rates],
            ARateCards: {
                route: RatesDomains.ARateCards,
                All: {
                    route: CommonRoutes.All,
                    Create: {
                        route: 'create',
                    },
                    Edit: {
                        route: SkyNetDomainSubRoutes.EDIT,
                        params: [{
                            name: 'key',
                            required: true,
                        }],
                        RateCard: {
                            route: RateCardsTabs.RateCard,
                        },
                        BaseLease: {
                            route: RateCardsTabs.BaseLease,
                        },
                        AdditionalFees: {
                            route: RateCardsTabs.AdditionalFees,
                        },
                    },
                },
                BulkEdit: {
                    route: SkyNetDomainRoutes.BULK_EDIT,
                    params: [{
                        name: 'key',
                        required: true,
                    }],
                    BaseLease: {
                        route: RateCardsTabs.BaseLease,
                    },
                    AdditionalFees: {
                        route: RateCardsTabs.AdditionalFees,
                    },
                },
            },
            CRateCards: {
                route: RatesDomains.CRateCards,
                ...Object.entries(RateCardsTabs).reduce((acc, [
                    key,
                    value,
                ]) => {
                    return {
                        ...acc,
                        [key]: {
                            route: value,
                        },
                    }
                }, {} as Record<string, { route: string }>),
            },
        }

        return createRoutesConfig(skyNetNavigate)(config) as unknown as {
            ARateCards: RouteNode,
            CRateCards: RouteNode,
        }
    }, [skyNetNavigate])
}
